import type { InputBuilderProps } from "./InputBuilder.tsx";

export function extractInputBuilderProps<T extends InputBuilderProps>(
  props: T,
): {
  inputBuilderProps: InputBuilderProps;
  restProps: Omit<T, keyof InputBuilderProps>;
} {
  const { left, size, loadingState, leadingText, ...restProps } = props;

  const inputBuilderProps: InputBuilderProps = {
    left,
    size: size ?? "m",
    loadingState,
    leadingText,
  };

  const filteredInputBuilderProps: InputBuilderProps = Object.keys(
    inputBuilderProps,
  ).reduce<InputBuilderProps>((acc, key) => {
    if (inputBuilderProps[key as keyof InputBuilderProps] !== undefined) {
      // @ts-expect-error We need to filter out undefined values, so that we can set that default in the component that uses it.
      acc[key as keyof InputBuilderProps] =
        inputBuilderProps[key as keyof InputBuilderProps];
    }
    return acc;
  }, {});

  return {
    inputBuilderProps: filteredInputBuilderProps,
    restProps,
  };
}
